module.exports = __webpack_public_path__ + "img/sahrawiarabdemocraticrepublic.26f613a0.svg";